import { joinPack } from '../../lib/analytics/events';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Pack.module.scss';
import Button from '../../components/Button';
import { useLocation } from 'react-router-dom';

export default function JoinPackComplete() {
  const { t } = useTranslation();
  useEffect(() => joinPack.successfullyJoinedPack(), []);

  const {
    state: { packName },
  } = useLocation<{ packName?: string }>();

  return (
    <div className={styles.simpleFullWidthWrapper}>
      <div className={styles.simpleContainer}>
        <div className={styles.simpleSpacer} />
        <div className={styles.simpleHeaderContainer}>
          <h1 className={styles.simpleHeader}>{t('thank_you_exclamation')}</h1>
          <p className={styles.simpleSubheader}>
            {t('youve_successfully_joined_pack_name', { packName: packName || t('the_pack') })}
          </p>
        </div>
        <Button
          className={styles.simpleButton}
          onClick={() => {
            window.open('fi://closeappview');
          }}
        >
          {t('done')}
        </Button>
      </div>
    </div>
  );
}
